import React, {useCallback} from 'react';
import {GatewayGetSchema} from '../../../../../api/DBSchema/Gateway';
import {SMCCheckbox} from '../../../../../components/Simple/SMCCheckbox';
import {useTranslation} from 'react-i18next';
import SMCLabel from '../../../../../components/Simple/SMCLabel';
import EditorLayout from '../../../../../components/Layouts/EditorLayout';
import Indentation from '../../../../../components/Simple/Indentation';
import {SMCToggleSwitch} from "../../../../../components/Simple/SMCToggleSwitch";
import EmailsTable from "./EmailsTable";
const pageSchema = GatewayGetSchema.pages.reportRecipients;
const pageId = pageSchema.pageId;

function BaseReportRecipients({
    pageData,
    setObjectData,
    pageDisabled,
    isHasEditPermissionForReportsConfig
}) {
    const { t } = useTranslation();

    const setPageValue = useCallback((param, newValue) => {
        setObjectData([pageId, param], newValue);
    }, [setObjectData]);

    const sendToOwner           = pageData[pageSchema.sendToOwner];
    const additionalEmails      = pageData[pageSchema.additionalEmails];
    const additionalEmailsStr      = pageData[pageSchema.additionalEmailsStr];
    const unsubscribedEmails    = pageData[pageSchema.unsubscribedEmails];
    const unsubscribedEmailsStr    = pageData[pageSchema.unsubscribedEmailsStr];

    const recipientOnChangeCallback = (emailsList) => {
        const mailsAsStr = emailsList.join(";");
        setPageValue(pageSchema.additionalEmailsStr, mailsAsStr)
    }

    const unsubscribersOnChangeCallback = (emailsList) => {
        const mailsAsStr = emailsList.join(";");
        setPageValue(pageSchema.unsubscribedEmailsStr, mailsAsStr)
    }

    return (
        <EditorLayout>
            <SMCLabel bold>{t('SMP.PLAN.SERVICES.REPORT_RCIPIENTS.LINE1')}</SMCLabel>
            <Indentation>
                {/* Send to owner */}
                <SMCToggleSwitch
                    disabled={pageDisabled}
                    checked={sendToOwner}
                    onChange={checked => setPageValue(pageSchema.sendToOwner, checked)}
                    label={t('SMP.PLAN.SERVICES.REPORT_RCIPIENTS.SEND_TO_OWNER')}
                />
                {/* Additional emails */}
                <SMCToggleSwitch
                    disabled={pageDisabled}
                    checked={additionalEmails}
                    onChange={checked => setPageValue(pageSchema.additionalEmails, checked)}
                    label={t('SMP.PLAN.SERVICES.REPORT_RCIPIENTS.ADDITIONAL_EMAILS')}
                    inline
                />
                <Indentation>
                {additionalEmails &&
                    (<EmailsTable
                        disabled={pageDisabled}
                        emailsList={additionalEmailsStr? additionalEmailsStr.split(";") : []}
                        onChange={recipientOnChangeCallback}
                    />)
                }
                </Indentation>
                {
                    isHasEditPermissionForReportsConfig && (
                    <>
                    <SMCCheckbox
                        disabled={pageDisabled}
                        checked={unsubscribedEmails}
                        onChange={e => setPageValue(pageSchema.unsubscribedEmails, e.target.checked)}
                        label={t('SMP.PLAN.SERVICES.REPORT_RCIPIENTS.UNSUBSCRIBED_EMAILS')}
                    />
                    <Indentation>
                        {unsubscribedEmails &&
                            (<EmailsTable
                                    disabled={pageDisabled}
                                    emailsList={unsubscribedEmailsStr? unsubscribedEmailsStr.split(";") : []}
                                    onChange={unsubscribersOnChangeCallback}
                                />
                            )
                        }
                    </Indentation>
                    </>
                    )
                }
            </Indentation>
        </EditorLayout>
    );
}

export default BaseReportRecipients;